import React from 'react'
import "./BallotTable.css"
import BallotRow from './Ballot/BallotRow'
import HeaderElement from '../../../components/HeaderElement/HeaderElement'
import strings from '../../../locales/ro.json'

export default function BallotTable({ title, type, ballots }) {
    return (
        <div className='ballot-table-container'>
            <HeaderElement headerText={title} />
            {ballots && ballots.length > 0 ? (
                ballots.map((ballot) => {
                    return <BallotRow title={ballot.title} type={type} id={ballot.id} key={ballot.id} parentID={ballot.parent_id === null? 0 : ballot.parent_id} voters={ballot.inherit_voters} />
                })
            ) : (
                <div className='no-ballots-text'>
                    <p>{strings.votes.noVotes}</p>
                </div>
            )}
        </div>
    );
}